import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SURQUAL_CHANNEL_PAGE_CHANNEL_GROUP2_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "CHANNEL_GROUP_2",
  path: "channel-group2",
  model: {
    entityName: "short_name",
    label: "CHANNEL_GROUP_2",
    path: "/api/channel-groups-2",
    bulkPath: "/api/channel-groups-2/bulk-updates",
    name: "channel_group2",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        align: "right",
        key: "order",
        order: 4,
        label: "RANK",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/channel-groups-2/export" },
    import: { path: "/api/channel-groups-2/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "integer",
        key: "order",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "order",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "order",
        flex: "50%",
      },
    ],
    rankable: {
      column: "order",
    },
  },
};

const SURQUAL_CHANNEL_PAGE_CHANNEL_GROUP1_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "CHANNEL_GROUP_1",
  path: "channel-group1",
  model: {
    entityName: "short_name",
    label: "CHANNEL_GROUP_1",
    path: "/api/channel-groups-1",
    bulkPath: "/api/channel-groups-1/bulk-updates",
    name: "channel_group1",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "group2.short_name",
        order: 4,
        label: "CHANNEL_GROUP_2",
        visible: true,
      },
      {
        align: "right",
        key: "order",
        order: 5,
        label: "RANK",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/channel-groups-1/export" },
    import: { path: "/api/channel-groups-1/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/channel-groups-2/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group2",
        label: "CHANNEL_GROUP_2",
        labelKey: "short_name",
        subCreationForm: SURQUAL_CHANNEL_PAGE_CHANNEL_GROUP2_TAB,
      },
      {
        inputType: "integer",
        key: "order",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    copyOptions: [],
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group2",
        flex: "100%",
      },
      {
        key: "order",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group2",
        flex: "100%",
      },
      {
        key: "order",
        flex: "50%",
      },
    ],
    rankable: {
      column: "order",
    },
  },
};

export const SURQUAL_CHANNEL_PAGE_CHANNEL_TAB: ConfigurationPageTables = {
  description: "CONF_DESC_SELFMAPPING_CHANNEL",
  type: ConfigurationPageType.TABLE,
  label: "CHANNEL",
  path: "channels",
  model: {
    entityName: "short_name",
    label: "CHANNEL",
    path: "/api/channels",
    bulkPath: "/api/channels/bulk-updates",
    name: "channel",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "properties",
        order: 4,
        label: "PROPERTIES",
        sortable: false,
        type: FormatType.LIST,
        labelKey: "short_name",
        numberOfColumnItemsToDisplay: 2,
        tooltip: true,
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 5,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 6,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 7,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "group1.short_name",
        order: 8,
        label: "CHANNEL_GROUP_1",
        visible: true,
      },
      {
        key: "channel_nandc.short_name",
        order: 9,
        label: "CHANNEL_NC",
        visible: true,
      },
      {
        align: "left",
        key: "with_commission",
        label: "WITH_COMMISSION",
        order: 10,
        visible: true,
        type: FormatType.BOOLEAN,
      },
      {
        align: "left",
        key: "is_commission_included",
        label: "IS_COMMISSION_INCLUDED",
        order: 11,
        visible: true,
        type: FormatType.BOOLEAN,
      },
      {
        align: "right",
        key: "commission_relative_amount",
        label: "COMMISSION_RELATIVE_AMOUNT",
        order: 12,
        visible: true,
        type: FormatType.NUMBER,
        maximumFractionDigits: 2,
      },
      {
        align: "right",
        key: "commission_absolute_amount",
        label: "COMMISSION_ABSOLUTE_AMOUNT",
        order: 13,
        visible: true,
        type: FormatType.NUMBER,
        maximumFractionDigits: 2,
      },
      {
        align: "right",
        key: "order",
        label: "RANK",
        order: 99,
        visible: false,
        type: FormatType.NUMBER,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/channels/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.SelectMultiple,
        mustTranslateOptions: false,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "properties",
        labelKey: "hebergement_nom_court",
        label: "PROPERTIES",
        lookup: "property__in",
        controlledInputSize: true,
        numericIds: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/channels/export" },
    import: { path: "/api/channels/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/channel-groups-1/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group1",
        label: "CHANNEL_GROUP_1",
        labelKey: "short_name",
        subCreationForm: SURQUAL_CHANNEL_PAGE_CHANNEL_GROUP1_TAB,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/channels-nandc/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "channel_nandc",
        label: "CHANNEL_NC",
        labelKey: "short_name",
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
      {
        inputType: "integer",
        key: "order",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
      {
        key: "separatorCommission",
        label: "ESTIMATED_COMMISSION_COST",
        subLabel: "ESTIMATED_COMMISSION_COST_SUBLABEL",
        type: ConfigurationFormType.Separator,
      },
      {
        key: "with_commission",
        label: "WITH_COMMISSION",
        type: ConfigurationFormType.Check,
        watchedBy: [
          "is_commission_included",
          "commission_relative_amount",
          "commission_absolute_amount",
        ],
      },
      {
        key: "is_commission_included",
        label: "IS_COMMISSION_INCLUDED",
        type: ConfigurationFormType.Check,
        enableField: "with_commission",
      },
      {
        inputType: "number",
        key: "commission_relative_amount",
        label: "COMMISSION_RELATIVE_AMOUNT",
        type: ConfigurationFormType.Input,
        enableField: "with_commission",
      },
      {
        inputType: "number",
        key: "commission_absolute_amount",
        label: "COMMISSION_ABSOLUTE_AMOUNT",
        type: ConfigurationFormType.Input,
        enableField: "with_commission",
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "channel_nandc",
        flex: "50%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "order",
        flex: "100%",
      },
      {
        key: "separatorCommission",
        flex: "100%",
      },
      {
        key: "with_commission",
        flex: "50%",
      },
      {
        key: "is_commission_included",
        flex: "50%",
      },
      {
        key: "commission_relative_amount",
        flex: "50%",
      },
      {
        key: "commission_absolute_amount",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "channel_nandc",
        flex: "50%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "order",
        flex: "50%",
      },
      {
        key: "separatorCommission",
        flex: "100%",
      },
      {
        key: "with_commission",
        flex: "50%",
      },
      {
        key: "is_commission_included",
        flex: "50%",
      },
      {
        key: "commission_relative_amount",
        flex: "50%",
      },
      {
        key: "commission_absolute_amount",
        flex: "50%",
      },
    ],
    editSelectedOptions: [
      {
        key: "channel_nandc",
        flex: "50%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "with_commission",
        flex: "50%",
      },
      {
        key: "is_commission_included",
        flex: "50%",
      },
      {
        key: "commission_relative_amount",
        flex: "50%",
      },
      {
        key: "commission_absolute_amount",
        flex: "50%",
      },
    ],
    rankable: {
      column: "order",
    },
  },
};

const SURQUAL_CHANNEL_PAGE_CHANNEL_NANDC_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "CHANNEL_NC",
  path: "channels-nandc",
  separator: true,
  model: {
    entityName: "short_name",
    label: "CHANNEL_NC",
    path: "/api/channels-nandc",
    name: "channel_nandc",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "exclude_from_model",
        order: 8,
        label: "EXCLUDE_FROM_MODEL",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: { color: "text.cell" },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: { color: "text.accent" },
          },
        ],
        type: FormatType.BOOLEAN,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
      {
        key: "exclude_from_model",
        label: "EXCLUDE_FROM_MODEL",
        type: ConfigurationFormType.Check,
      },
    ],
    creatable: false,
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "short_name",
        flex: "50%",
        readonly: true,
      },
      {
        key: "name",
        flex: "100%",
        readonly: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "exclude_from_model",
        flex: "50%",
      },
    ],
    deletable: false,
  },
};

export const SURQUAL_CHANNEL_PAGE = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "CHANNEL",
  pageLabel: "CHANNEL_TITLE_SURQUAL",
  menuLabel: "CHANNEL",
  name: "channel",
  path: "canal",
  tabs: [
    SURQUAL_CHANNEL_PAGE_CHANNEL_TAB,
    SURQUAL_CHANNEL_PAGE_CHANNEL_GROUP1_TAB,
    SURQUAL_CHANNEL_PAGE_CHANNEL_GROUP2_TAB,
    SURQUAL_CHANNEL_PAGE_CHANNEL_NANDC_TAB,
  ],
};
